import { render, staticRenderFns } from "./DialogEditUser.vue?vue&type=template&id=0fd47830"
import script from "./DialogEditUser.vue?vue&type=script&lang=js"
export * from "./DialogEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd47830')) {
      api.createRecord('0fd47830', component.options)
    } else {
      api.reload('0fd47830', component.options)
    }
    module.hot.accept("./DialogEditUser.vue?vue&type=template&id=0fd47830", function () {
      api.rerender('0fd47830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/Dialogs/DialogEditUser.vue"
export default component.exports